<article class="page-container flex flex-column">
  <!-- <div>
    <button pButton icon="fas fa-plus" class="p-button-info p-button-outlined" [pTooltip]="screen.labels.add"
      ></button>
  </div> -->

  <p-accordion styleClass="hide-from-small pb-2 accordion__tab--no-margin" expandIcon="far fa-eye"
    collapseIcon="far fa-eye-slash">
    <p-accordionTab class="m-0" [header]="screen.labels.filters">
      <label for="dtMobileNameFilter">{{screen.labels.name}}</label>
      <input pInputText type="text" [style.width]="'100%'" name="dtMobileNameFilter" [(ngModel)]="dtNameFilter"
        (input)="dt.filter(dtNameFilter, 'name', 'contains')">
    </p-accordionTab>
  </p-accordion>

  <div class="inline-flex">
    <p-table #dt [value]="locations" [paginator]="true" [rows]="20" [contextMenu]="cm"
      [(contextMenuSelection)]="selectedLocation" (onContextMenuSelect)="setContextMenuItems()" class="col-12 p-0">

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup class="hide-on-small">
          <col data-id="number" [style.width.px]="50">
          <col data-id="status" [style.width.px]="50">
          <col data-id="id" [style.width.px]="175">
          <col data-id="name">
          <col data-id="user" [style.width.px]="175" class="hide-on-medium">
          <col data-id="date" [style.width.px]="125" class="hide-on-medium">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th scope="number" colspan="2" rowspan="2"></th>
          <th scope="id" rowspan="2">{{screen.labels.code}}</th>
          <th scope="name">{{screen.labels.name}}</th>
          <th scope="update" colspan="2" class="text-center hide-on-medium">{{screen.labels.update}}</th>
        </tr>
        <tr>
          <th scope="id">
            <input pInputText type="text" [style.width]="'100%'" name="nameFilter" [(ngModel)]="dtNameFilter"
              (input)="dt.filter(dtNameFilter, 'name', 'contains')">
          </th>
          <th scope="update_user" class="hide-on-medium">{{screen.labels.user}}</th>
          <th scope="update_date" class="hide-on-medium">{{screen.labels.date}}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-location let-rowIndex="rowIndex">
        <!-- TODO: Enable back context menu -->
        <!-- [pContextMenuRow]="location" -->
        <tr>
          <td class="text-right hide-on-small">{{rowIndex + 1}}</td>
          <td class="text-center hide-on-small">
            <i class="fas fa-circle" [class.text-success]="location.status" [class.text-danger]="!location.status"
              [pTooltip]="location.status ? screen.labels.enabled : screen.labels.disabled"></i>
          </td>
          <td>
            <div class="inline-flex align-items-center">
              <i class="fas fa-circle hide-from-small mr-2" [class.text-success]="location.status"
                [class.text-danger]="!location.status"
                [pTooltip]="location.status ? screen.labels.enabled : screen.labels.disabled"></i>
              <span>{{location.id}}</span>
            </div>
          </td>
          <td>{{location.name}}</td>
          <td class="hide-on-medium">{{location.user}}</td>
          <td class="text-right hide-on-medium">{{location.date | date:'dd-MM-yyyy'}}</td>
        </tr>
      </ng-template>

    </p-table>
    <p-contextMenu #cm [model]="options"></p-contextMenu>
  </div>
</article>

<p-dialog header="{{modal.title}}" [(visible)]="modal.isVisible" [modal]="true" [blockScroll]="true"
  [style]="{width: '35%', maxHeight: '50%'}">
  <form class="flex flex-column" (validate)="save()" novalidate>
    <div class="inline-flex align-items-center">
      <label class="col-3 pt-0 pl-0" for="id">{{screen.labels.code}}</label>
      <span class="col-9 pt-0 pr-0 form__field">
        <input pInputText validation [required]="true" name="id" [(ngModel)]="modal.value.id" autocomplete="off"
          [disabled]="modal.value.id != null" />
      </span>
    </div>

    <div class="inline-flex align-items-center">
      <label class="col-3 pt-0 pl-0" for="name">{{screen.labels.name}}</label>
      <span class="col-9 pt-0 pr-0 form__field">
        <input pInputText validation [required]="true" name="name" [(ngModel)]="modal.value.name" autocomplete="off" />
      </span>
    </div>

    <div class="align-self-end">
      <button pButton [label]="screen.actions.save" class="p-button-success p-button-outlined" type="submit"
        *ngIf="!loading"></button>
      <button pButton [label]="screen.actions.save" class="p-button-success p-button-outlined" type="button"
        [icon]="loadingIcon" *ngIf="loading"></button>
    </div>
  </form>
</p-dialog>